// extracted by mini-css-extract-plugin
module.exports = {"label":"clinical-portal-3__Label__label"};